<template>
  <div
    class="
      stage-mobile-preview
      d-flex
      justify-content-center
      align-items-center
      mt-4
    "
  >
    <div class="stage-mobile-preview-wrapper">
      <div class="container-fluid pt-3 position-relative fh">
        <div class="mobile-main-wrap">
          <iframe
            :src="currentUrl"
            width="100%"
            height="100%"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var vm;
export default {
  data() {
    return {
      currentUrl: "",
    };
  },
  computed: {},
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
  },
  beforeCreate() {},
  created() {
    vm = this;
    //self.uid = self.getSessionUserId();
  },
  mounted() {
    vm.currentUrl = location.href;
  },
  methods: {},
};
</script>